(function () {
    'use strict';

    angular
        .module('app')
        .controller('BuyReadyReportController', BuyReadyReportController);

    function BuyReadyReportController($scope, $rootScope, $location, $window, $state, $filter, $stateParams, cfpLoadingBar, UserService, toaster, PrototypeService, SeasonService) {
        var model = this;
        model.buyReadyReport = [];
        model.stockNumber = "";
        model.factoryKey = "";
        model.buyReady = false;
        model.prototypeSeasonalId = "";
        model.buyReadyOverrides = [];
        model.seasons = [];
        model.currentUser = $rootScope.globals.currentUser;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        /*
        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] === 18) {
                if (userPermissionRow[1] === 1) {
                    model.SystemMessageRead = true;
                }
            }
        });

        if (!model.SystemMessageRead) {
            $state.go("permissionDenied");
        }*/

        //check Permissions ReadOnly_
        model.RunReport = false;
        model.ExecuteBuyReady = false;

        //dev proto, dev pattern, and commercializations permissions
        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            //admin
            if (userPermissionRow[0] === 18) {
                if (userPermissionRow[1] === 1) {
                    model.AdminUser = true;
                }
            }

            //dev pattern
            if (userPermissionRow[0] == 11) {
                if (userPermissionRow[1] == 1) {
                    //this is CriticalPathDevPatternRead permission
                    model.RunReport = true;
                }
                if (userPermissionRow[1] == 2) {
                    //this is CriticalPathDevPatternEdit permission
                    model.ExecuteBuyReady = true;
                }
            }

            //dev proto
            if (userPermissionRow[0] == 12) {
                if (userPermissionRow[1] == 1) {
                    //this is CriticalPathDevPrototypeRead permission
                    model.RunReport = true;
                }
                if (userPermissionRow[1] == 2) {
                    //this is CriticalPathDevPrototypeEdit permission
                    model.ExecuteBuyReady = true;
                }
            }

            //commercialization
            if (userPermissionRow[0] == 13) {
                if (userPermissionRow[1] == 1) {
                    //this is CriticalPathCommercializationRead permission
                    model.RunReport = true;
                }
                if (userPermissionRow[1] == 2) {
                    //this is CriticalPathCommercializationEdit permission
                    model.ExecuteBuyReady = true;
                }
            }

        });

        if (model.currentUser.isFactoryUser)
        {
            model.RunReport = false;
            model.ExecuteBuyReady = false;
        }

        //If user doesnt have Read or Edit, redirect to Permission Denied Page
        if (model.RunReport == false && model.ExecuteBuyReady == false) {
            $state.go('permissionDenied');
        }

        /*SeasonService.getSeasons().then(function (data) {
            model.seasons = data;
        });*/
       
        //function to run the report
        $scope.runReport = function (executeBuyReady, runForSeason) {

            if (model.prototypeSeasonalId == "") {
                model.prototypeSeasonalId = 0;
            }

            if (runForSeason)
            {
                PrototypeService.runBuyReadyReportForSeason(model.SeasonId).then(function (response) {
                    if (response) {
                        model.buyReadyReport = response;

                        if (model.prototypeSeasonalId == 0) {
                            model.prototypeSeasonalId = "";
                        }
                    }
                    else {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'No buy ready data found.',
                            timeout: 5000
                        });
                    }
                },
            function (error, status) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'No buy ready data found.',
                    timeout: 5000
                });
            });
            }
            else
            {
                PrototypeService.runBuyReadyReport(model.stockNumber, model.factoryKey, model.prototypeSeasonalId, executeBuyReady).then(function (response) {
                    if (response) {
                        model.buyReadyReport = response;

                        if (model.prototypeSeasonalId == 0) {
                            model.prototypeSeasonalId = "";
                        }
                    }
                    else {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'No buy ready data found.',
                            timeout: 5000
                        });
                    }
                },
            function (error, status) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'No buy ready data found.',
                    timeout: 5000
                });
            });
            }

            
        }

        if ($stateParams.prototypeSeasonalId != null && $stateParams.prototypeSeasonalId > 0) {
            console.log($stateParams.prototypeSeasonalId);
            model.prototypeSeasonalId = $stateParams.prototypeSeasonalId;
            $scope.runReport(false);
        } else {
            $rootScope.hideBusyWait();
        }

    }
})();
